import React, { useState } from 'react';
import {
	Box,
	Button,
	ButtonBase,
	Grid,
	InputBase,
	Typography,
} from '@mui/material';
import Logo from '../assets/images/Logo.png';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import { useNavigate } from 'react-router-dom';
import TextInput from '../components/TextInput';
import { helperText } from '../assets/theme/Theme';
import { createNewUserAccount } from '../services/UserService';
import { toast } from 'react-toastify';
import { WEB_ACCOUNT } from '../Utils/Enums';

const initialErrorState = {
	status: false,
	msg: '',
};

function CreateAccount() {
	const navigator = useNavigate();
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [reEnterPassword, setReEnterPassword] = useState('');
	const [firstNameError, setFirstNameError] = useState(initialErrorState);
	const [lastNameError, setLastNameError] = useState(initialErrorState);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [passwordReEnterError, setPasswordReEnterError] =
		useState(initialErrorState);
	const [show, setShow] = useState(false);
	const [showReEntered, setShowReEntered] = useState(false);

	function onChangeFirstName(value) {
		setFirstNameError(initialErrorState);
		setFirstName(value);
	}

	function onChangeLastName(value) {
		setLastNameError(initialErrorState);
		setLastName(value);
	}

	function onChangeEmail(value) {
		setEmailError(initialErrorState);
		setEmail(value);
	}

	function onChangePassword(event) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	function onChangeReEnterPassword(event) {
		setPasswordReEnterError(initialErrorState);
		setReEnterPassword(event.target.value);
	}

	function onValidateInputs() {
		let error = false;

		if (!firstName || firstName === '') {
			setFirstNameError({ status: true, msg: 'First Name is Required.' });
			error = true;
		}
		if (!lastName || lastName === '') {
			setLastNameError({ status: true, msg: 'Last Name is Required.' });
			error = true;
		}
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}
		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}
		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}
		if (!reEnterPassword || reEnterPassword === '') {
			setPasswordReEnterError({
				status: true,
				msg: 'Re-enter the password.',
			});
			error = true;
		}
		if (password.length < 8) {
			setPasswordError({
				status: true,
				msg: 'Password should be at least 8 characters long.',
			});
			error = true;
		}
		if (password.length >= 8 && password !== reEnterPassword) {
			setPasswordReEnterError({
				status: true,
				msg: 'Password is not matched.',
			});
			error = true;
		}

		return error;
	}

	async function onClickCreateAccount() {
		const error = onValidateInputs();

		if (error) {
			return;
		} else {
			const body = {
				firstname: firstName,
				lastname: lastName,
				username: `${firstName} ${lastName}`,
				email: email,
				password: password,
				accountType: WEB_ACCOUNT,
			};
			const response = await createNewUserAccount(body);
			if (response.message === 'Success') {
				navigator('/');
				toast.success('Account created successfully.');
			} else {
				toast.error(response.message);
			}
		}
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}>
			<Grid container justifyContent={'center'}>
				<Grid item xs={10} md={4}>
					<Grid
						container
						flexDirection={'row'}
						justifyContent={'center'}
						alignItems={'center'}>
						<Box
							component={'img'}
							src={Logo}
							sx={{
								padding: '2px',
								borderRadius: '5px',
							}}
							width={180}
							height={45}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						md={12}
						style={{
							textAlign: 'left',
							border: '1px solid #F4F5F6',
							boxShadow:
								'0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
							marginTop: '20px',
							paddingTop: '20px',
							padding: '15px',
							borderRadius: '10px',
							backgroundColor: '#FFF',
						}}>
						<Grid container paddingBottom="10px">
							<Grid item xs={12} md={6}>
								<Typography
									fontSize={'16px'}
									color={'#7C7C7C'}
									paddingBottom="10px">
									First Name
								</Typography>
								<TextInput
									error={firstNameError.status}
									onChange={onChangeFirstName}
									width="95%"
									style={{
										marginTop: '5px',
										marginBottom: '10px',
									}}
								/>
								<Typography style={helperText}>
									{firstNameError.msg}
								</Typography>
							</Grid>
							<Grid item xs={12} md={6}>
								<Typography
									fontSize={'16px'}
									color={'#7C7C7C'}
									paddingBottom="10px">
									Last Name
								</Typography>
								<TextInput
									error={lastNameError.status}
									onChange={onChangeLastName}
									width="100%"
									style={{
										marginTop: '5px',
										marginBottom: '10px',
									}}
								/>
								<Typography style={helperText}>
									{lastNameError.msg}
								</Typography>
							</Grid>
						</Grid>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingBottom="10px">
							Email
						</Typography>
						<TextInput
							error={emailError.status}
							onChange={onChangeEmail}
							width="100%"
							style={{
								marginTop: '5px',
								marginBottom: '10px',
							}}
						/>
						<Typography style={helperText}>
							{emailError.msg}
						</Typography>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingY="10px">
							Password
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={show === false ? 'password' : 'text'}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={passwordError.status}
								onChange={onChangePassword}
							/>
							<ButtonBase onClick={() => setShow(!show)}>
								{show ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{passwordError.msg}
						</Typography>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingY="10px">
							Re-enter Password
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordReEnterError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={
									showReEntered === false
										? 'password'
										: 'text'
								}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={passwordReEnterError.status}
								onChange={onChangeReEnterPassword}
							/>
							<ButtonBase
								onClick={() =>
									setShowReEntered(!showReEntered)
								}>
								{showReEntered ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{passwordReEnterError.msg}
						</Typography>
						<Grid container justifyContent={'center'}>
							<Button
								onClick={onClickCreateAccount}
								style={{
									width: '100%',
									boxShadow: 'none',
									marginTop: '10px',
									textTransform: 'none',
									backgroundColor: '#28696D',
								}}
								variant="contained">
								Create Account
							</Button>
							<Typography
								variant="subtitle2"
								style={{
									color: '#777E91',
									paddingTop: '15px',
									paddingBottom: '5px',
								}}>
								<a href="/" style={{ textDecoration: 'none' }}>
									<span
										style={{
											color: '#777E90',
											cursor: 'pointer',
										}}>
										Back to Login
									</span>
								</a>
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}

export default CreateAccount;
